module.exports = __webpack_public_path__ + "img/CS26Q-中_13.2b39a27b.jpg";